/* eslint-disable react/no-array-index-key */
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import { useEffect, useRef, useState } from 'react';
import If from 'global/ErrorHandlers/If';
import IconBulletPIN from 'assets/customIcon/IconBulletPIN';
import Image from 'global/Image';
import { ErrorMessageWrapper, InputPINNumber, InputPINWrapper } from './styled';

const KEY_CODE_BACKSPACE = 8;
const KEY_CODE_ENTER = 13;

interface LoginInputPinProps {
  onChangePIN: (pin: string) => void;
  onPressEnter: (pin: string) => void;
  errorMsg?: string;
  isError?: boolean;
}

export default function LoginInputPin({
  onChangePIN,
  onPressEnter,
  errorMsg,
  isError = false,
}: LoginInputPinProps) {
  const inputRef = useRef<HTMLInputElement>();

  const [pinValue, setPinValue] = useState('');

  const onChangeInput = (e) => {
    const { value } = e.target;

    if (value.length > 12) return;
    setPinValue(value);
  };

  const onKeyDown = (e) => {
    const numKeyValue = Number(e.key);

    if (e.keyCode === KEY_CODE_ENTER && pinValue.length >= 6) {
      onPressEnter(pinValue);
    }

    if (Number.isNaN(numKeyValue) && e.keyCode !== KEY_CODE_BACKSPACE && e.key.length === 1) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (onChangePIN) {
      onChangePIN(pinValue);
    }
  }, [pinValue]);

  useEffect(() => {
    if (isError) {
      // reset input on error
      setPinValue('');
    }
  }, [isError]);

  return (
    <>
      <Flex
        justify="center"
        width="100%"
        style={{ cursor: 'text' }}
        onClick={() => inputRef.current.focus()}
      >
        <InputPINWrapper>
          <InputPINNumber
            value={pinValue}
            onChange={onChangeInput}
            onKeyDown={onKeyDown}
            pattern="\d*"
            ref={inputRef}
            onBlur={({ target }) => target.focus()}
            autoFocus
          />
          <div id="pin-mask">
            {Array.from(pinValue).map((value, index) => <IconBulletPIN key={index} />)}
          </div>
        </InputPINWrapper>

      </Flex>
      <If condition={errorMsg && errorMsg !== ''}>
        <ErrorMessageWrapper>
          <Text
            align="center"
            color={color.sunsetOrange}
            data-cy="input-pin-error"
          >
            <Image src="icon/alert/info-warning.svg" style={{ marginRight: 4 }} />
            {errorMsg}
          </Text>
        </ErrorMessageWrapper>
      </If>
    </>
  );
}

LoginInputPin.defaultProps = {
  errorMsg: '',
};
